module.exports = __webpack_public_path__ + "static/media/product vide.93a04e7e.mp4";